import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  of,
  Subject,
} from 'rxjs';
import { environment } from '../../environment/environment';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { restEndPoints } from '../app.constants';
import { loginParam, reponseObject } from '../models/response.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl = environment.apiHost;
  private sessionExpiredSubject = new Subject<void>();
  public selectedOrg = new Subject<any>();
  authState$ = new BehaviorSubject<boolean>(false);
  // Observable to listen for session expiration
  sessionExpired$ = this.sessionExpiredSubject.asObservable();
  users = [];
  constructor(
    private httpClient: HttpClient,
    private _snackBar: MatSnackBar,
  ) {}

  authLogin(email: string, password: string): Observable<string | null> {
    return this.httpClient
      .post<any>(`${this.baseUrl}api/Auth/Login`, { email, password })
      .pipe(
        map((response: reponseObject) => {
          // Check if response contains authToken and return it
          if (response && response.value) {
            return response.value.authToken; // Return the authToken
          }
          return null; // Return null if authToken is not found
        }),
        catchError((error) => {
          // Show the error message in a snackbar
          this._snackBar.open(
            'Login failed. Please check your credentials and try again.',
            'Close',
            {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            },
          );

          // Return null in case of an error
          return of(null);
        }),
      );
  }

  // Method to trigger the session expired event
  emitSessionExpired() {
    this.sessionExpiredSubject.next();
  }

  notifyAuthState(isAuthenticated: boolean) {
    this.authState$.next(isAuthenticated);
  }

  // Show a snackbar when the session has expired
  showSessionExpiredMessage(): void {
    this._snackBar.open('Session expired. Please log in again.', 'Close', {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
    sessionStorage.clear();
  }

  setToken(token: string) {
    sessionStorage.setItem('authToken', token); // Store token in sessionStorage
  }

  getToken(): string | null {
    return sessionStorage.getItem('authToken'); // Retrieve token
  }

  logout(): void {
    // Clear token from storage
    sessionStorage.clear();
  }

  auth(email: string): Observable<reponseObject> {
    return this.httpClient.post<reponseObject>(
      `${this.baseUrl}${restEndPoints.authuthetication.auth}?userName=${email}`,
      {},
    );
  }

  validateLogin(data: loginParam): Observable<reponseObject> {
    return this.httpClient.post<reponseObject>(
      `${this.baseUrl}${restEndPoints.authuthetication.validateLogin}`,
      data,
    );
  }

  // TODO: Future requirement design yet to be given
  // changePassword(data: any): Observable<reponseObject> {
  //   return this.httpClient.post<reponseObject>(
  //     `${this.baseUrl}${restEndPoints.authuthetication.changePassword}`,
  //     data,
  //   );
  // }

  getDashboardScreenbyOrg(): Observable<reponseObject> {
    return this.httpClient.get<reponseObject>(
      `${this.baseUrl}${restEndPoints.authuthetication.screenbyOrg}`,
    );
  }

  search(data: any, page: string): Observable<reponseObject> {
    return this.httpClient.post<reponseObject>(
      `${this.baseUrl}api/${page}/searchParams`,
      data,
    );
  }
}
